const projects = [
  {
    key: 1,
    title: "Melodate",
    emoji: "🎶",
    color: "#BFD3B2",
    tags: ["product", "development", "design"],
    url: "https://melodate-remix.fly.dev",
    description:
      "A dating-app-esque experience that allows the user to discover new artists (think Spotify Tinder)",
  },

  {
    key: 2,
    title: "Learn Baybayin",
    emoji: "🇵🇭",
    color: "#C9B1E7",
    tags: ["machine learning", "development"],
    url: "https://marielpacada.github.io/learn-baybayin/",
    description:
      "An educational tool for teaching how to write in Baybayin, a pre-colonial script from the Philippines",
  },

  {
    key: 3,
    title: "Ukutabs Redesign",
    emoji: "🌺",
    color: "#E58AA5",
    tags: ["design"],
    url: "https://marielpacada.github.io/redesign-writeup/",
    description:
      "A complete redesign of website ukutabs.com, improving usability and accessibility",
  },

  {
    key: 4,
    title: "Simple Colors API",
    emoji: "🍭",
    color: "#E7B1BC",
    tags: ["product"],
    url: "https://simple-colors-api.herokuapp.com/",
    description:
      "A RESTful API that allows the developer to categorize 140 web colors into simple color groups",
  },

  {
    key: 5,
    title: "Mental Health in Tech",
    emoji: "💼",
    color: "#D6D8D4",
    tags: ["data analysis", "machine learning"],
    url: "https://marielpacada.github.io/mental-health-in-tech/",
    description:
      "Correlational and classification analysis on mental health within the tech industry",
  },

  {
    key: 6,
    title: "Hate Crimes in the US",
    emoji: "🇺🇸",
    color: "#91B2CA",
    tags: ["data analysis"],
    url: "https://marielpacada.github.io/us-hate-crime/",
    description:
      "Exploratory data analysis on the prevalence of hate crimes in the US amid the 2016 election",
  },
];

export default projects;
